import supergasbrasFavicon from "assets/supergasbras/icons/favicon.png";
import logoMin from "assets/supergasbras/logos/logoMin.svg";
import logoFull from "assets/supergasbras/logos/logoFull.svg";

import Envrionments from "./enums/envrionments";

const DEFAULT_SERVICE_NOW_URL =
  "https://shvenergy.service-now.com/supergasbras?id=msc_cat_item&sys_id=1f09ad7cdbab9b00c50a9414db961968";

export const serviceNowUrl =
  process.env.REACT_APP_SERVICENOW_URL ?? DEFAULT_SERVICE_NOW_URL;

const getEnvironmentVariables = () => {
  const clientKey = process.env.REACT_APP_CLIENT_KEY;

  const environmentVariables = {
    [Envrionments.SUPERGASBRAS]: {
      clientName: "Pedir gás",
      faviconImg: supergasbrasFavicon,
      logoMin,
      logoFull,
    },
  };

  return environmentVariables[clientKey as Envrionments];
};

const loadInitialConfig = () => {
  const environmentVariables = getEnvironmentVariables();

  const faviconElm = document.getElementById("favicon") as HTMLLinkElement;
  faviconElm.href = environmentVariables.faviconImg;

  document.title = `Backoffice - ${environmentVariables.clientName}`;
};

export { getEnvironmentVariables, loadInitialConfig };
